// Lightweight public-funnel tracking. Fire-and-forget. Safe no-op on any failure.
const API = process.env.REACT_APP_BACKEND_URL;
const SESSION_KEY = 'evalpro_public_session';

function generateSessionId() {
  if (typeof crypto !== 'undefined' && crypto.randomUUID) {
    return crypto.randomUUID();
  }
  return `sess_${Date.now()}_${Math.random().toString(36).slice(2, 12)}`;
}

export function getOrCreateSessionId() {
  if (typeof window === 'undefined') return null;
  try {
    let id = window.sessionStorage.getItem(SESSION_KEY);
    if (!id) {
      id = generateSessionId();
      window.sessionStorage.setItem(SESSION_KEY, id);
    }
    return id;
  } catch {
    return null;
  }
}

// Track once per (session, event_type) within the same tab — avoids inflating counts on re-renders.
const FIRED_KEY = 'evalpro_public_fired';

function alreadyFired(eventType) {
  if (typeof window === 'undefined') return false;
  try {
    const raw = window.sessionStorage.getItem(FIRED_KEY);
    const set = raw ? JSON.parse(raw) : {};
    return Boolean(set[eventType]);
  } catch {
    return false;
  }
}

function markFired(eventType) {
  if (typeof window === 'undefined') return;
  try {
    const raw = window.sessionStorage.getItem(FIRED_KEY);
    const set = raw ? JSON.parse(raw) : {};
    set[eventType] = Date.now();
    window.sessionStorage.setItem(FIRED_KEY, JSON.stringify(set));
  } catch { /* noop */ }
}

export function trackUsageEvent(eventType, { once = true } = {}) {
  if (!API) return;
  if (once && alreadyFired(eventType)) return;
  const sessionId = getOrCreateSessionId();
  if (!sessionId) return;

  // Fire and forget. Do not block UI.
  fetch(`${API}/api/track/public-event`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ session_id: sessionId, event_type: eventType }),
    keepalive: true,
  }).catch(() => { /* silently ignore */ });

  markFired(eventType);
}
